import { render, staticRenderFns } from "./BuyAmazon.vue?vue&type=template&id=21160a9f&"
import script from "./BuyAmazon.vue?vue&type=script&lang=js&"
export * from "./BuyAmazon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports